import script from "./AvisoVistaPrevia.vue?vue&type=script&setup=true&lang=js"
export * from "./AvisoVistaPrevia.vue?vue&type=script&setup=true&lang=js"

import "./AvisoVistaPrevia.vue?vue&type=style&index=0&id=39f08fc4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39f08fc4"]])

export default __exports__